import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";
import GeoZones from "./GeoZones";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRICER]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={List}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.PRICERS.CREATE.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRICER]: SUBMODULES.ADMIN_CREATE }}
        WrappedComponent={Create}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PRICERS.DETAIL.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRICER]: SUBMODULES.ADMIN_DETAIL }}
        WrappedComponent={Detail}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PRICERS.DELETE.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRICER]: SUBMODULES.ADMIN_DELETE }}
        WrappedComponent={Delete}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.PRICERS.GEO_ZONES.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRICER]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={GeoZones}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.PRICERS.REFERENTIALS.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRICER]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={GeoZones}
      />
    ),
  },
];

export default routes;
